'use client';
import ClientModal, { type ClientModalProps } from '@/legacy/components/apps/ClientModal';
import { store } from '@/legacy/components/apps/Jotai';
import { atom, useAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import type React from 'react';
import { useEffect } from 'react';

type Props = {};

type JSXModal = React.ReactNode;

type FunctionAtomProps = {
	addLayer: (key: string, jsx: JSXModal, props?: Omit<ClientModalProps, 'modalKey'>) => void;
	deleteLayer: (key: string, closeMs?: number) => void;
	lazyDeleteLayer: (key: string) => Promise<string>;
};

const layerAtom = atom<Record<string, JSXModal>>({});
const sortAtom = atom<string[]>([]);
export const deleteAtom = atom<Map<string, NodeJS.Timeout>>(new Map<string, NodeJS.Timeout>());
const setSort = (fn: (state: string[]) => string[]) => store.set(sortAtom, (...state) => fn(...state));
const setDelete = (fn: (state: Map<string, NodeJS.Timeout>) => Map<string, NodeJS.Timeout>) =>
	store.set(deleteAtom, (...state) => fn(...state));
const setLayer = (fn: (state: Record<string, JSXModal>) => Record<string, JSXModal>) =>
	store.set(layerAtom, (...state) => fn(...state));

const getDeleteList = () => store.get(deleteAtom);

const closeMsDefault = 300;

export const modalFunctionAtom = atom<FunctionAtomProps>({
	addLayer: (key: string, jsx: JSXModal, props?: Omit<ClientModalProps, 'modalKey'>) => {
		const deleteList = getDeleteList();
		const target = deleteList.get(key);
		if (target) {
			clearTimeout(target);
		}
		const Temp = (
			<ClientModal key={key} {...props} modalKey={key}>
				{jsx}
			</ClientModal>
		);

		setLayer((state) => ({ ...state, [key]: Temp }));

		setSort((state) =>
			[...state.filter((i) => i !== key), key].filter((value, index, self) => self.indexOf(value) === index)
		);
	},
	deleteLayer: (key: string, closeMs = closeMsDefault) => {
		const deleteList = getDeleteList();
		const target = deleteList.get(key);
		if (target) {
			clearTimeout(target);
		}

		const timmer = setTimeout(() => {
			setDelete((state) => {
				state.delete(key);
				return state;
			});
			setSort((state) => state.filter((element) => element !== key));
		}, closeMs);

		setDelete((state) => state.set(key, timmer));
	},
	lazyDeleteLayer: (key: string, closeMs = closeMsDefault) => {
		return new Promise<string>((resolve, reject) => {
			const deleteList = getDeleteList();
			const target = deleteList.get(key);
			if (target) {
				clearTimeout(target);
			}

			setSort((state) => state.filter((element) => element !== key));

			const timmer = setTimeout(() => {
				resolve('lazyDeleteLayer sucess');
			}, closeMs);

			setDelete((state) => state.set(key, timmer));
		});
	},
});

export const { addLayer, deleteLayer, lazyDeleteLayer } = store.get(modalFunctionAtom);

const ClientModalProvider = (props: Props) => {
	const [layer, setLayer] = useAtom(layerAtom);
	const [sort, setSort] = useAtom(sortAtom);
	const [dlist, setDlist] = useAtom(deleteAtom);
	const pathname = usePathname();

	// const setFunction = useSetAtom(modalFunctionAtom)

	useEffect(() => {
		// sort 새로 고침 등에서 사라지는 로직
		const layerKey = Object.keys(layer);
		const temp = layer;

		layerKey.forEach((name) => {
			if (sort.includes(name)) return;
			delete temp[name];
		});
		setLayer({ ...temp });
	}, [sort]);

	// URL 변경 시 모든 모달 닫기
	useEffect(() => {
		// 현재 열려있는 모든 모달 닫기
		sort.forEach((key) => {
			deleteLayer(key, 0);
		});
	}, [pathname]);

	// const Root = useMemo(() => {
	// 	return (
	// 		<>
	// 			{sort.map((name) => {
	// 				return layer[name]
	// 				// const Test = () => layer[name]
	// 				// return <Test key={name}></Test>
	// 			})}
	// 		</>
	// 	)
	// }, [layer])

	// return Root

	return (
		<>
			{sort.map((name) => {
				return layer[name];
				// const Test = () => layer[name]
				// return <Test key={name}></Test>
			})}
		</>
	);
};

const ClientModalRoot = (props: Props) => {
	return (
		<>
			<div id="crew-root">
				<ClientModalProvider />
			</div>
		</>
	);
};

export default ClientModalRoot;
